<template>
	<iframe
		ref="iframe"
		:src="file"
		class="h-screen w-screen"
		@load="onLoad"
	/>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const file = route.query.file as string
const iframe = ref<HTMLIFrameElement>()

const onLoad = async () => {
	iframe.value?.contentWindow?.print()
}
</script>
